import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText, renderStandardPictureElement } from "../../utils";

export default {
    title: "Components/Media Bar",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-media-bar",
    args: {
        label: getDummyText(15),
        title: getDummyText(10),
        copyText: getDummyText(190),
        withGridSystem: false,
    },
    argTypes: {
        label: {
            control: "text",
        },
        title: {
            control: "text",
        },
        copyText: {
            control: "text",
        },
        withGridSystem: {
            control: "boolean",
        },
    },
};

const MediaBarTemplate = ({ label, title, copyText, withGridSystem }) => {
    const gridLayout = (content) => {
        return html`
            <div class="row">
                <div
                    class="gr-10 push-1 gr-12@m push-0@m ux-u-margin-vertical-50"
                >
                    ${content}
                </div>
            </div>
        `;
    };

    const element = html`
        <ux-iws-media-bar>
            <div slot="media">
                ${renderStandardPictureElement({
                    width: 1200,
                    height: 600,
                })}
            </div>
            <div slot="content">
                <div
                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-margin-bottom-5"
                >
                    ${label}
                </div>
                <div class="title-normal ux-u-margin-bottom-10">${title}</div>
                <div
                    class="ux-text-normal ux-u-margin-children-0 ux-u-margin-bottom-30"
                >
                    <p>${copyText}</p>
                </div>
                <button type="button" class="ux-button ux-button--green">
                    login
                </button>
                <button class="btn" type="button">register</button>
            </div>
        </ux-iws-media-bar>
    `;

    return withGridSystem ? gridLayout(element) : element;
};

export const Default = MediaBarTemplate.bind({});

export const WithGridSystem = MediaBarTemplate.bind({});
WithGridSystem.args = {
    withGridSystem: true,
};
